import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ALLOWED_HOSTS, UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';

import { Blog } from '@sparro/app/core/models/blog.model';
import { environment } from '@sparro/env/environment';


@Component({
  selector: 'uni-blog-card-title',
  templateUrl: './blog-card-title.component.html',
  styleUrls: ['./blog-card-title.component.scss']
})
export class BlogCardTitleComponent implements OnInit {
  @Input() blog: Blog;
  @Input() cardWidth: number = null;
  @Input() dialogOpenable: boolean;
  @Input() self: boolean;
  @Input() host: ALLOWED_HOSTS;
  @Output() openDialogEvent = new EventEmitter();

  defaultTitle: string = UNI_CONSTANTS.STRINGS.UNTITLED_BLOG;

  constructor() { }

  ngOnInit() {

  }

  openDialog(): boolean {
    if (this.dialogOpenable) {
      this.openDialogEvent.emit();
    }
    return !this.dialogOpenable;
  }

  getBlogDetailLink(): string {
    if (this.host === UNI_CONSTANTS.HOSTS.EVALUATION) {
        return `${environment.evalUrl}/${this.blog.chamber_id}/journal/${this.blog.id}`;
    } else {
      if (this.blog.slug) {
        return `${environment.postUrl}${this.blog.slug}`;
      } else if (this.self || this.blog.status === 'DRAFT') {
        return `${environment.postUrl}edit/${this.blog.uuid}/`;
      }
    }
  }
}
